export default "__VITE_ASSET__Cm_REA3p__"